// client/src/hooks/useDashboardOrigination.ts
import { useQuery } from "@tanstack/react-query";
import type { OriginationPayload } from "@shared/dashboardOrigination";

/** Same freshness as useDashboardOverview: live on navigation, focus and every 60s. */
export function useDashboardOrigination() {
  return useQuery<OriginationPayload>({
    queryKey: ["/api/dashboard/origination"],
    staleTime: 15_000,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
